module.exports = __webpack_public_path__ + "static/media/create_what.0491d087.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/create_what.png
// module id = 227
// module chunks = 0